"use client";

export { default } from "../../src/app/prompts/error";
